var nb = require('../../nb');
var accountItem = nb.define({
    view: {
        'class': ['account-item', nb.bind('className')],
        tag: 'li',
        $html: {
            tag: 'a',
            href: nb.bind('href'),
            $html: [{
                'class': 'text',
                $text: nb.bind('linkName')
            }, {
                tag: 'i',
                'class': nb.bind('iconName')
            }]
        }
    }
});
var accountList = nb.define({
    parent: nb.view.List,
    view: {
        'class': 'account-list',
        tag: 'ul'
    }
});
var accountMenu = nb.define({
    view: {
        'class': 'account-menu',
        $html: {
            $type: accountList,
            $model:'accountList'
        }
    }
});

module.exports = {
    accountMenu:accountMenu,
    accountItem:accountItem
};



//////////////////
// WEBPACK FOOTER
// ../src/js/view/header/AccountMenu.js
// module id = 9
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32